module.exports = __webpack_public_path__ + "img/providers_hero_mobile.841642b3.jpg";